import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Tabs } from "antd";
import MailingReport from "./mailingreport";
import ListReport from "./lists-report";
import ListSelection from "./list-selection";
import MailingResponseLTV from "../DataModule/mailingResponseLTVData";
const { TabPane } = Tabs;

const MailingResponseTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [forcedTabKey, setForcedTabKey] = useState(null);

  // Define tab paths mapping using useMemo to prevent recreation on each render
  const tabKeyToPath = useMemo(() => ({
    1: "mailing-report",
    2: "list-report",
    3: "mailing-response-ltv-data",
    4: "list-selection"
  }), []);

  // Create reverse mapping from path to key
  const pathToTabKey = useMemo(() => {
    return Object.entries(tabKeyToPath).reduce(
      (acc, [key, path]) => {
        acc[path] = key;
        return acc;
      },
      {}
    );
  }, [tabKeyToPath]);

  // Get current path from URL - handle both direct paths and nested paths
  const pathParts = location.pathname.split("/");
  const basePath = pathParts[1]; // Get the first part after the domain
  
  // Determine active tab key based on current path
  // Check if the base path matches any of our known paths
  const computedKey = pathToTabKey[basePath] || 
                     (basePath === "list-report" ? "2" : 
                      basePath === "mailing-report" ? "1" : 
                      basePath === "mailing-response-ltv-data" ? "3" : 
                      basePath === "list-selection" ? "4" : "1");
  const activeTabKey = forcedTabKey || computedKey;

  // Set default tab on initial load if not on a specific tab path
  useEffect(() => {
    // Check if current base path is one of our valid tab paths
    const isValidTabPath = Object.values(tabKeyToPath).includes(basePath) || 
                          basePath === "list-report" || 
                          basePath === "mailing-report" || 
                          basePath === "mailing-response-ltv-data" ||
                          basePath === "list-selection";
                          
    if (!isValidTabPath) {
      navigate(`/mailing-report`, { replace: true });
    }
  }, [basePath, navigate, tabKeyToPath]);

  // Handle tab change
  const handleTabChange = (key) => {
    setForcedTabKey(null);
    navigate(`/${tabKeyToPath[key]}`);
  };

  return (
    <div className="page-wrapper">
      <div className="p-2">
        <Tabs
          activeKey={activeTabKey}
          onChange={handleTabChange}
          className=""
          type="card"
          size="small"
          tabBarStyle={{ marginBottom: "5px" }}
        >
          <TabPane tab="Mailing Response Report" key="1">
            <MailingReport />
          </TabPane>
          
          <TabPane tab="List Report" key="2">
            <ListReport />
          </TabPane>
          
          <TabPane tab="Mailing Response Data" key="3">
            <MailingResponseLTV />
          </TabPane>
          
          <TabPane tab="List Selection" key="4">
            <ListSelection />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default MailingResponseTabs;
